import "./VopPage.scss";
import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="vop-page">
      <article className="vop-page__article">
        <h1>VŠEOBECNÉ OBCHODNÉ PODMIENKY (VOP)</h1>
        <h2>
          pre portál capoeira.sk (platby členských príspevkov a účasť na
          tréningoch)
        </h2>

        <p>
          Tieto Všeobecné obchodné podmienky (ďalej len „VOP“) upravujú práva a
          povinnosti medzi prevádzkovateľom webového sídla a poskytovateľom
          športových aktivít a záujemcami o členstvo, resp. aktívnymi členmi
          združenia.
        </p>

        <h2>Článok I. Definície a prevádzkovateľ</h2>

        <h3>1. Prevádzkovateľ portálu (Združenie):</h3>
        <ul>
          <li>
            <strong>Názov:</strong> Kvalitná škola, o. z.
          </li>
          <li>
            <strong>Sídlo:</strong> Karpatské námestie 7770/10A 83106 Bratislava
            - mestská časť Rača
          </li>
          <li>
            <strong>IČO:</strong> 57302146
          </li>
          <li>
            <strong>Registrácia:</strong> Vedená v Registri občianskych združení
            Ministerstva vnútra SR pod číslom: VVS/1-900/90-73078
          </li>
          <li>
            <strong>E-mail:</strong>{" "}
            <a href="mailto:info@capoeira.sk">info@capoeira.sk</a>
          </li>
          <li>
            <strong>Telefónne číslo:</strong>{" "}
            <a href="tel:+421948748999">0948 748 999</a>
          </li>
        </ul>
        <p>
          <em>(ďalej len „Združenie“)</em>
        </p>

        <h3>2. Používateľ / Člen:</h3>
        <ul>
          <li>
            <strong>Záujemca / Nový člen:</strong> Fyzická osoba, ktorá
            prejavila záujem o účasť na tréningoch Capoeiry (alebo jej zákonný
            zástupca, ak ide o dieťa mladšie ako 18 rokov).
          </li>
          <li>
            <strong>Člen:</strong> Fyzická osoba, ktorá riadne odoslala
            registračný formulár na webe capoeira.sk, súhlasila s týmito VOP,
            stanovami Združenia a uhradila príslušný členský príspevok.
          </li>
        </ul>

        <h3>3. Služby:</h3>
        <p>
          Organizácia športových, pohybových a vzdelávacích aktivít so zameraním
          na Capoeiru, ktoré Združenie organizuje pre svojich členov na základe
          svojich stanov.
        </p>

        <h2>Článok II. Vznik členstva a objednávka (registrácia)</h2>
        <p>
          Pre účasť na pravidelných tréningoch a aktivitách organizovaných
          Združením na webe capoeira.sk je potrebná registrácia a vznik členstva
          v Združení (prípadne štatút pridruženého/prispievajúceho člena v
          zmysle Stanov).
        </p>
        <p>
          Registrácia prebieha elektronicky prostredníctvom formulára na
          webstránke capoeira.sk.
        </p>
        <p>Odoslaním registračného formulára Záujemca:</p>
        <ul>
          <li>Žiada o prijatie za člena Združenia.</li>
          <li>
            Potvrdzuje, že sa oboznámil s týmito VOP a Stanovami Združenia a
            bezvýhradne s nimi súhlasí.
          </li>
          <li>
            Potvrdzuje, že jeho zdravotný stav (alebo stav ním zastupovaného
            maloletého dieťaťa) umožňuje plnú fyzickú záťaž spojenú s cvičením
            Capoeiry.
          </li>
        </ul>
        <p>
          Zmluva o členstve (resp. dohoda o účasti na aktivitách) je uzatvorená
          momentom potvrdenia registrácie zo strany Združenia a pripísaním prvej
          platby členského príspevku na účet Združenia.
        </p>

        <h2>Článok III. Skúšobný tréning zadarmo (1x zadarmo)</h2>
        <h3>Základné pravidlo pre nováčikov:</h3>
        <ul>
          <li>
            Každý nový záujemca (ktorý doposiaľ nebol členom Združenia a
            nenavštívil žiadny tréning) má právo prísť sa pozrieť a bezplatne si
            vyskúšať jeden (1) tréning zadarmo (tzv. skúšobný tréning).
          </li>
          <li>
            Na bezplatný tréning je potrebné sa vopred prihlásiť prostredníctvom
            formulára na webe capoeira.sk alebo dohodou (e-mailom/telefonicky) s
            trénerom, aby sa zabezpečila voľná kapacita na tréningu.
          </li>
          <li>
            Po absolvovaní tohto skúšobného tréningu sa záujemca rozhodne, či má
            záujem o riadne členstvo a pokračovanie v tréningoch.
          </li>
          <li>
            Počas skúšobného tréningu je účastník povinný riadiť sa pokynmi
            trénera a zodpovedá za svoju bezpečnosť a svoj zdravotný stav v
            plnom rozsahu.
          </li>
        </ul>

        <h2>Článok IV. Členské príspevky a platobné podmienky</h2>
        <p>
          Členovia Združenia prispievajú na činnosť združenia a pokrytie
          nákladov spojených s tréningovým procesom (prenájom hál, tréneri,
          pomôcky) formou členských príspevkov. Člen si môže vybrať z
          nasledovných variantov predplatného obdobia:
        </p>

        <table className="pricing-table">
          <thead>
            <tr>
              <th>Typ členského príspevku</th>
              <th>Doba platnosti</th>
              <th>Splatnosť</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <strong>Mesačné členské</strong>
              </td>
              <td>1 kalendárny mesiac</td>
              <td>Vopred pred začiatkom obdobia</td>
            </tr>
            <tr>
              <td>
                <strong>Štvrťročné členské</strong>
              </td>
              <td>3 po sebe nasledujúce mesiace</td>
              <td>Vopred pred začiatkom obdobia</td>
            </tr>
            <tr>
              <td>
                <strong>Ročné členské</strong>
              </td>
              <td>12 po sebe nasledujúcich mesiacov</td>
              <td>Vopred pred začiatkom obdobia</td>
            </tr>
          </tbody>
        </table>

        <ul>
          <li>
            <strong>Výška príspevkov:</strong> Aktuálna výška členských
            príspevkov pre jednotlivé varianty je zverejnená v cenníku na
            stránke capoeira.sk. Združenie nie je platcom DPH (príspevky
            nepodliehajú dani z pridanej hodnoty, keďže ide o činnosť v zmysle
            poslania občianskeho združenia).
          </li>
          <li>
            <strong>Spôsob úhrady:</strong> Členský príspevok je možné uhradiť
            spôsobmi ponúkanými na portáli (napr. online platobnou kartou
            prostredníctvom platobnej brány, prevodom na bankový účet Združenia
            alebo iným dohodnutým spôsobom).
          </li>
          <li>
            <strong>Obnovovanie členstva:</strong> Členský príspevok na ďalšie
            obdobie musí byť uhradený najneskôr do dňa uplynutia platnosti
            predchádzajúceho uhradeného obdobia. V prípade neuhradenia príspevku
            môže byť účasť na tréningoch pozastavená.
          </li>
        </ul>

        <h2>Článok V. Práva a povinnosti člena (Tréningový poriadok)</h2>
        <ul>
          <li>
            <strong>Účasť na tréningoch:</strong> Člen má právo zúčastňovať sa
            tréningov Capoeiry v rozsahu predplateného obdobia a zvolenej
            skupiny.
          </li>
          <li>
            <strong>Zdravotná spôsobilosť:</strong> Každý člen vyhlasuje, že je
            zdravotne spôsobilý na vykonávanie fyzicky náročného športu
            (Capoeira). Združenie ani tréneri nenesú zodpovednosť za zranenia,
            úrazy alebo zhoršenie zdravotného stavu spôsobené zamlčaním
            zdravotných obmedzení.
          </li>
          <li>
            <strong>Pravidlá správania (Etika Capoeiry):</strong> Člen je
            povinný na tréningoch dodržiavať pokyny trénera, správať sa s
            rešpektom k ostatným cvičencom a dodržiavať čistotu a bezpečnosť v
            priestoroch telocvične.
          </li>
          <li>
            <strong>Vybavenie:</strong> Člen je povinný na tréningy nosiť vhodné
            športové oblečenie (prípadne predpísanú uniformu/oblečenie pre
            Capoeiru, ak je vyžadované).
          </li>
        </ul>

        <h2>Článok VI. Odstúpenie od zmluvy a ukončenie členstva</h2>

        <h3>Zákonné odstúpenie do 14 dní (pre spotrebiteľov):</h3>
        <ul>
          <li>
            V zmysle Zákona o ochrane spotrebiteľa pri zmluvách uzatvorených na
            diaľku má Člen právo odstúpiť od zmluvy o členstve do 14
            kalendárnych dní od jej uzatvorenia (registrácie a platby) bez
            uvedenia dôvodu.
          </li>
          <li>Odstúpenie sa realizuje zaslaním e-mailu na adresu Združenia.</li>
          <li>
            <strong>Upozornenie:</strong> Ak Člen začal aktívne využívať
            tréningové služby pred uplynutím tejto 14-dňovej lehoty (t. j.
            absolvoval tréningy s jeho výslovným súhlasom), stráca právo na
            vrátenie alikvotnej časti príspevku za už absolvované tréningy.
          </li>
        </ul>

        <h3>Bežné ukončenie členstva:</h3>
        <ul>
          <li>
            Členstvo zaniká uplynutím predplateného obdobia (mesačné,
            štvrťročné, ročné), pokiaľ nedôjde k úhrade príspevku na ďalšie
            obdobie.
          </li>
          <li>
            Člen môže kedykoľvek požiadať o písomné ukončenie členstva. Už
            uhradené členské príspevky sa spätne nevracajú (s výnimkou závažných
            zdravotných dôvodov, ktoré znemožňujú cvičenie po dobu dlhšiu ako 2
            mesiace, doložených lekárskym potvrdením – v takom prípade môže
            vedenie Združenia rozhodnúť o alikvotnom vrátení alebo presunutí
            platnosti príspevku na inú osobu/obdobie).
          </li>
        </ul>

        <h2>Článok VII. Reklamácie a alternatívne riešenie sporov (ARS)</h2>
        <ul>
          <li>
            V prípade nespokojnosti s kvalitou poskytovaných služieb (napr.
            neohlásené zrušenie tréningov bez náhrady) má Člen právo uplatniť
            reklamáciu písomne na e-mailovú adresu Združenia.
          </li>
          <li>
            Združenie vyrieši reklamáciu bezodkladne, najneskôr do 30 dní od jej
            doručenia.
          </li>
          <li>
            Pokiaľ sa spor medzi Členom (spotrebiteľom) a Združením nevyrieši
            vzájomnou dohodou, má Člen právo podať návrh na začatie
            alternatívneho riešenia sporu subjektu alternatívneho riešenia
            sporov v zmysle zákona č. 391/2015 Z. z. o alternatívnom riešení
            spotrebiteľských sporov.
          </li>
          <li>
            Príslušným subjektom je Slovenská obchodná inšpekcia (SOI) (
            <a
              href="https://www.soi.sk"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.soi.sk
            </a>
            ) alebo iná oprávnená právnická osoba zapísaná v zozname subjektov
            ARS vedenom Ministerstvom hospodárstva SR.
          </li>
        </ul>

        <h2>Článok VIII. Ochrana osobných údajov (GDPR)</h2>
        <ul>
          <li>
            Spracúvanie osobných údajov Členov sa riadi Nariadením Európskeho
            parlamentu a Rady (EÚ) 2016/679 (GDPR) a Zákonom č. 18/2018 Z. z. o
            ochrane osobných údajov.
          </li>
          <li>
            Združenie spracúva osobné údaje (meno, priezvisko, dátum narodenia,
            e-mail, telefón, prípadne údaje o zákonnom zástupcovi) na účely
            registrácie členov, správy platieb, informovania o tréningoch a
            plnenia zákonných povinností OZ.
          </li>
          <li>
            Kompletné informácie o spracúvaní osobných údajov a právach
            dotknutých osôb sú zverejnené v samostatnom dokumente „Ochrana
            osobných údajov (Privacy Policy)“ na webe capoeira.sk.
          </li>
        </ul>

        <h2>Článok IX. Záverečné ustanovenia</h2>
        <ul>
          <li>
            Tieto VOP nadobúdajú platnosť a účinnosť dňom{" "}
            <strong>[Doplňte dátum, napr. 15.07.2026]</strong>.
          </li>
          <li>
            Združenie si vyhradzuje právo na zmenu týchto VOP. O zmenách VOP
            bude Člen informovaný e-mailom alebo oznamom na webe najmenej 14 dní
            pred nadobudnutím účinnosti nových VOP.
          </li>
          <li>
            Právne vzťahy neupravené týmito VOP sa riadia Stanovami OZ Kvalitná
            škola, Občianskym zákonníkom SR a príslušnými slovenskými a
            európskymi právnymi predpismi na ochranu spotrebiteľa.
          </li>
        </ul>
      </article>
    </div>
  );
};

export default TermsAndConditions;
